import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import MarkdownIt from 'markdown-it';
import { getRelativePath } from '@utils/index';
import { useRouter } from 'next/router';

const md = new MarkdownIt({
  html: true,
  linkify: false,
});
const renderMarkdown = (value) => (value ? md.render(value) : '');

const propTypes = {
  text: PropTypes.string,
  Component: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const MarkDownIt = ({ text = '', Component, className = '' }) => {
  const router = useRouter();
  const containerRef = useRef(null);
  const handleClick = (event) => {
    const link = event.target.closest('a');
    if (link && link.getAttribute('href')) {
      let href = link.getAttribute('href');
      href = getRelativePath(href);
      // Check if it's a local link
      if (href.startsWith('/')) {
        event.preventDefault();
        router.push(href);
      }
    }
  };
  useEffect(() => {
    const contentEl = containerRef.current;
    /* istanbul ignore else */
    if (contentEl) {
      contentEl.addEventListener('click', handleClick);
    }
    return () => {
      /* istanbul ignore else */
      if (contentEl) {
        contentEl.removeEventListener('click', handleClick);
      }
    };
  }, []);
  useEffect(() => {
    if (window.twttr && window.twttr.widgets) {
      window.twttr.widgets.load();
    }
  });
  return (
    <Component
      ref={containerRef}
      className={className}
      dangerouslySetInnerHTML={{ __html: renderMarkdown(text) }}
    />
  );
};

MarkDownIt.propTypes = propTypes;
export default MarkDownIt;
